import { Injectable, inject } from '@angular/core';
import { AppStateService } from '@siza-staff-care/shared/app-state';
import { ControlSecurityService } from './control-security.service';
import { EditFlags_All, EditFlags_Update } from './edit-flags-constants';
import { IStore } from '@siza-staff-care/shared/ui-components/store-registry';
import { getKeyForRootRoute, normaliseRoute } from '../menu-routes/root-route-to-security-mapping';
import { Router } from '@angular/router';

const DEBUG = false;

@Injectable({
	providedIn: 'root',
})
export class EditorSecurityService {
	private controlSecurity = inject(ControlSecurityService);
	private appState = inject(AppStateService);
	private router = inject(Router);

	getEditorSecurity(store?: IStore) {
		const menuKey = this.controlSecurity.getMenuKeyFromRoute();
		if (menuKey === undefined) {
			return EditFlags_All;
		}
		const editorMap = this.appState.editorMap;

		const route = normaliseRoute(this.router.routerState.snapshot.url);
		const securityKey = getKeyForRootRoute(route, this.appState);

		if (!editorMap) {
			return EditFlags_All;
		}

		let storeKey = store?.storeKey ?? securityKey;

		const potentialStoreKeys: string[] = [];
		if (store && storeKey) {
			// Use a regex to check whether the store key starts with L and is followed by another capital letter
			// This was the pattern for "lookup" screens in the old client - e.g. LDocument for Admin > Document, etc.
			const storeKeyMatch = storeKey.match(/L[A-Z]/);
			if (storeKeyMatch) {
				// If so, remove the L
				storeKey = storeKey.substring(1);
			}
			potentialStoreKeys.push(storeKey);
		}

		if (!storeKey && store) {
			// Derive the storeKey from the store name
			const storeName = store.constructor.name;

			// Use a regex to remove the Store suffix and any pluralisation of the name, and any underscores;
			storeKey = storeName
				.replace(/Store$/i, '')
				.replace(/s$/i, '')
				.replace(/_/i, '');
			potentialStoreKeys.push(storeKey);

			// Use a regex to remove the Store suffix, and any underscores;
			storeKey = storeName.replace(/Store$/i, '').replace(/_/i, '');
			potentialStoreKeys.push(storeKey);
		}

		let key = '';
		// Try each of the potential keys
		for (const testKey of potentialStoreKeys) {
			key = testKey ? `${menuKey}.${testKey}` : menuKey;
			const result = editorMap[key];
			if (result !== undefined) {
				DEBUG && console.log('found entry for ' + key + ' = ' + result);
				return result;
			}
		}

		// No entry, so allow all
		DEBUG && console.log('no entry for ' + key + ' allowing all');
		return EditFlags_All;
	}

	/**
	 * Returns true if the user has the update edit flag for the store.
	 * @param store
	 * @returns
	 */
	hasEditFlags_Update(store: IStore) {
		const editFlags = this.getEditorSecurity(store);
		return !!(editFlags & EditFlags_Update);
	}
}
